import { Theme } from "@mui/material";
import { ReactElement } from "react";

import { Campaign } from "@/Components/Icons/Campaign";
import MROI from "@/Components/Icons/MROI";
import Sales from "@/Components/Icons/Sales";
import SatCurve from "@/Components/Icons/SatCurve";

export interface Module {
  id: string;
  title: string;
  content: string;
  route: string;
  icon: ReactElement;
}

export const getModules = (theme: Theme): Module[] => {
  const iconProps = { fontSize: "medium" as const, fill: theme.palette.mutinexMagenta.main };

  return [
    {
      id: "channel-roi",
      title: "Channel ROI",
      content: "See your best and worst performing channels",
      route: "/channel-roi",
      icon: <MROI {...iconProps} />,
    },
    {
      id: "investment-levels",
      title: "Investment Levels",
      content: "Find your point of optimal return",
      route: "/investment-levels",
      icon: <SatCurve {...iconProps} />,
    },
    {
      id: "campaigns",
      title: "Campaigns",
      content: "Review your campaigns for tactical improvements",
      route: "/campaigns",
      icon: <Campaign {...iconProps} />,
    },
    {
      id: "sales-drivers",
      title: "Sales Drivers",
      content: "Understand what's driving sales",
      route: "/sales-drivers",
      icon: <Sales {...iconProps} />,
    },
  ];
};
